(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
/* Sticky "Add to bag" bar on phones: shown while the main button is off screen */
(() => {
  const bar = document.querySelector("[data-buy-bar]");
  const main = document.querySelector("[data-main-buy]");
  if (!bar || !main || !("IntersectionObserver" in window)) return;
  new IntersectionObserver(([e]) => {
    bar.hidden = e.isIntersecting;
  }).observe(main);
})();

  } catch(e) { console.error(e); }
})();
})();
